import { createRoot } from 'react-dom/client'
import { setApiOptions } from '@mkmp/core'
import { AppProvider, AuthProvider } from './provider'
import App from './App.tsx'
import '@/assets/styles/globals.scss'

// import VConsole from 'vconsole'
// new VConsole()

if (process.env.NODE_ENV === 'development') {
  localStorage.setItem('token', 'fbcbe1d6fc664493bdb9ee562c43f393')
}

/**
 * 设置api配置
 */
setApiOptions({
  core: process.env.API_CORE_URL || '',
  prc: process.env.API_PRC_URL || ''
})

createRoot(document.getElementById('root')!).render(
  <AppProvider>
    <AuthProvider>
      <App />
    </AuthProvider>
  </AppProvider>
)
